/* Metadata tab: module summary, LOs, TC refs, quiz cfg. */
import { useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { adminApi } from "../portal/shell";

const COURSE_ID = "advanced-rpas-2026";

export function MetadataTab({ module, onChange }) {
  const [summary, setSummary] = useState(module.summary || "");
  const [estH, setEstH] = useState(module.est_hours || "");
  const [objectives, setObjectives] = useState((module.learning_objectives || []).join("\n"));
  const [refs, setRefs] = useState((module.tc_references || []).join("\n"));
  const [qCount, setQCount] = useState(module.quiz_question_count || 10);
  const [passPct, setPassPct] = useState(module.quiz_pass_pct || 70);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.updateModule(COURSE_ID, module.id, {
        summary: summary || null,
        est_hours: estH ? parseFloat(estH) : null,
        learning_objectives: objectives.split("\n").map((o) => o.trim()).filter(Boolean),
        tc_references: refs.split("\n").map((o) => o.trim()).filter(Boolean),
        quiz_question_count: qCount ? parseInt(qCount, 10) : null,
        quiz_pass_pct: passPct ? parseInt(passPct, 10) : null,
      });
      toast.success("Module updated");
      onChange();
    } catch (e) { toast.error(e.message || "Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="tbg-auth-editor" data-testid="authoring-metadata">
      <label>Summary</label>
      <textarea value={summary} onChange={(e) => setSummary(e.target.value)} style={{ minHeight: 70 }} />
      <label>Learning objectives (one per line)</label>
      <textarea value={objectives} onChange={(e) => setObjectives(e.target.value)} style={{ minHeight: 120 }} />
      <label>TC references (one per line)</label>
      <textarea value={refs} onChange={(e) => setRefs(e.target.value)} style={{ minHeight: 70 }} />
      <div className="row">
        <div style={{ flex: 1 }}>
          <label>Est. hours</label>
          <input type="number" step="0.5" value={estH} onChange={(e) => setEstH(e.target.value)} />
        </div>
        <div style={{ flex: 1 }}>
          <label>Quiz question count</label>
          <input type="number" value={qCount} onChange={(e) => setQCount(e.target.value)} />
        </div>
        <div style={{ flex: 1 }}>
          <label>Quiz pass %</label>
          <input type="number" value={passPct} onChange={(e) => setPassPct(e.target.value)} />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 10 }}>
        <button className="tbg-btn" onClick={save} disabled={saving} data-testid="authoring-metadata-save">
          <Save size={13} /> {saving ? "Saving…" : "Save metadata"}
        </button>
      </div>
    </div>
  );
}
